import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import wellnessHomepage from "../fragments/WellnessHomepage"

const query = gql`
  query GetWellnessHomepage {
    getWellnessHomepage {
      ...wellnessHomepage
    }
  }
  ${wellnessHomepage}
`
export const getWellnessHomepageKey = getQueryNames(query)[0]

export default query
